import { Fragment } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { ControlesLinha, ProcessoInput } from '../../components/RelatorioCivelComponents';

import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';

export default function Step04Reconvecao(props: RelatorioCivelStepProps) {
  const {
    novoProcessoReconvencao,
    setNovoProcessoReconvencao,
    adicionarProcesso,
    quantidadeLinhas,
    setQuantidadeLinhas,
    adicionarMultiplasLinhas,
    isViewMode,
    formData,
    renderTabelaProcessos,
  } = props;

  return (
    <Fragment>
      {!isViewMode && (
        <Row className="mb-4">
          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-bold">N.º do Processo</Form.Label>
              <ProcessoInput
                value={novoProcessoReconvencao}
                onChange={setNovoProcessoReconvencao}
                onAdicionar={() =>
                  adicionarProcesso('reconvencao', novoProcessoReconvencao, setNovoProcessoReconvencao)
                }
              />
              <Form.Text className="text-muted">
                Pressione Enter ou clique em Adicionar para incluir o processo na lista
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      )}

      {!isViewMode && (
        <ControlesLinha
          quantidade={quantidadeLinhas.reconvencao}
          onDecrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, reconvencao: Math.max(1, prev.reconvencao - 1) }))
          }
          onIncrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, reconvencao: Math.min(50, prev.reconvencao + 1) }))
          }
          onQuantidadeChange={(value: number) => setQuantidadeLinhas((prev) => ({ ...prev, reconvencao: value }))}
          onAdicionar={() => adicionarMultiplasLinhas('reconvencao')}
          totalLabel="Total de Processos"
          totalCount={formData.reconvencao.processos.length}
        />
      )}

      {renderTabelaProcessos('reconvencao', formData.reconvencao.processos)}
    </Fragment>
  );
}

